import React, { useEffect, useMemo, useRef, useState } from "react";
import { Input, DatePicker, Button, Card, Row, Col, Typography, Space, Checkbox, Table, Tag, message as antMessage } from "antd";
import { UploadOutlined, DeleteOutlined, FileExcelOutlined, DownloadOutlined } from "@ant-design/icons";
import Select from "react-select";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PhoneOutlined, LinkOutlined, CopyOutlined, CommentOutlined } from "@ant-design/icons";
import api from "../../../../../core/axios/axiosInstance";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { addCampaign } from "../../../../../core/data/redux/slices/WabaCampaignSlice";
import { fetchApprovedTemplates } from "../../../../../core/data/redux/slices/ApprovedTemplatesSlice";
import { fetchTags } from "../../../../../core/data/redux/slices/TagSlice";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
const { Text, Title } = Typography;

const WabaAddCampaign = () => {
  const navigate = useNavigate();
  const userProfile = useSelector((state) => state.profile);

  const isWhatsappConnected =
    userProfile?.accounts?.whatsapp?.isConnected;

  const { tags } = useSelector((state) => state.tags);

  const [campaignName, setCampaignName] = useState("");
  const [buttonConfig, setButtonConfig] = useState({});
  const [fieldDefaults, setFieldDefaults] = useState({});
  const [excelContacts, setExcelContacts] = useState([]); // [{name, number}]
  const [excelFileName, setExcelFileName] = useState("");
  const fileInputRef = useRef(null);

  const [selectedTemplateOption, setSelectedTemplateOption] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [scheduleEnabled, setScheduleEnabled] = useState(true);
  const [scheduleTime, setScheduleTime] = useState(null);

  console.log(selectedTemplateOption, "jhgfselectedTemplateOptiondchjk");

  const dispatch = useDispatch();
  const { loading: campaignLoading } = useSelector(
    (state) => state.wabaCampaign
  );
  const { data: approvedTemplatesData, loading: approvedTemplatesLoading } =
    useSelector((state) => state.approvedTemplates);
  useEffect(() => {
    dispatch(fetchTags());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchApprovedTemplates());
  }, [dispatch]);

  const approvedTemplates = useMemo(
    () =>
      approvedTemplatesData?.map((t) => ({
        label: t.name,
        value: t.metaTemplateId,
        template: t,
      })) || [],
    [approvedTemplatesData]
  );


  const selectedTemplate = selectedTemplateOption?.template;


  const handleTypeChange = (index, type) => {
    setButtonConfig((prev) => ({
      ...prev,
      [index]: { type }
    }));
  };

  const handleStaticText = (index, text) => {
    setButtonConfig((prev) => ({
      ...prev,
      [index]: { ...prev[index], value: text }
    }));
  };

  const handleDynamicField = (index, field) => {
    setButtonConfig((prev) => ({
      ...prev,
      [index]: { type: "dynamic", value: field }
    }));
  };

  const getButtonPreviewText = (btn, index) => {
    const cfg = buttonConfig[index];
    if (!cfg) return btn.text;

    if (cfg.type === "static") return cfg.value || btn.text;
    if (cfg.type === "dynamic") return `{{${cfg.value}}}`;

    return btn.text;
  };


  const renderHeader = () => {
    if (!headerComponent) return null;

    if (headerFormat === "text" && headerComponent.text) {
      return (
        <div style={{ fontWeight: 700, marginBottom: 12 }}>
          {headerComponent.text}
        </div>
      );
    }

    if (headerFormat === "image" && headerMediaUrl) {
      return (
        <img
          src={headerMediaUrl}
          alt="Header"
          style={{ width: "100%", borderRadius: 8 }}
        />
      );
    }

    if (headerFormat === "video" && headerMediaUrl) {
      return (
        <video
          src={headerMediaUrl}
          controls
          style={{ width: "100%", borderRadius: 8 }}
        />
      );
    }

    if (headerFormat === "document") {
      return (
        <div style={{ padding: 12, border: "1px solid #ddd", borderRadius: 8 }}>
          📄 {headerComponent.media?.fileName || "Document"}
        </div>
      );
    }

    return null;
  };




  const sendToOptions = useMemo(
    () =>
      tags?.map((tag) => ({
        label: `${tag.emoji} ${tag.tag}`,
        name: tag.tag,
        value: tag.tag_id,
      })) || [],
    [tags]
  );


  const headerComponent = selectedTemplate?.components?.find(c => c.type === "HEADER");
  const bodyComponent = selectedTemplate?.components?.find(c => c.type === "BODY");
  const footerComponent = selectedTemplate?.components?.find(c => c.type === "FOOTER");
  const buttonComponent = selectedTemplate?.components?.find(c => c.type === "BUTTONS");
  const headerFormat = headerComponent?.format?.toLowerCase();
  const headerMediaUrl = headerComponent?.media?.s3Url;

  const getBtnIcon = (type) => {
    if (type === "PHONE_NUMBER") return <PhoneOutlined />;
    if (type === "URL") return <LinkOutlined />;
    if (type === "COPY_CODE") return <CopyOutlined />;
    return <CommentOutlined />;
  };

  const handleDownloadSample = () => {
    const templateParams = bodyComponent?.example?.body_text_named_params?.map(p => p.param_name) || [];
    const headers = ["Name", "Number", ...templateParams];
    const row1 = ["John Doe", "971501234567", ...templateParams.map(() => "")];
    const row2 = ["Jane Smith", "971509876543", ...templateParams.map(() => "")];
    const csv = [headers, row1, row2].map(r => r.join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "sample_contacts.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split(".").pop().toLowerCase();
    if (!["xlsx", "xls", "csv"].includes(ext)) {
      antMessage.error("Please upload an Excel file (.xlsx, .xls, .csv)");
      e.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const wb = XLSX.read(evt.target.result, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { defval: "" });

        if (!rows.length) {
          antMessage.error("Excel file is empty");
          return;
        }

        // Detect columns case-insensitively
        const keys = Object.keys(rows[0]);
        const nameKey = keys.find(k => /name/i.test(k)) || keys[0];
        const numberKey = keys.find(k => /number|phone|mobile|tel/i.test(k)) || keys[1];

        const reservedKeys = new Set([nameKey, numberKey]);
        const extraKeys = keys.filter(k => !reservedKeys.has(k));

        const parsed = rows
          .map(row => {
            const extra = {};
            extraKeys.forEach(k => {
              const val = String(row[k] || "").trim();
              if (val) extra[k] = val;
            });
            return {
              name: String(row[nameKey] || "").trim(),
              number: String(row[numberKey] || "").replace(/[^0-9]/g, ""),
              ...extra,
            };
          })
          .filter(r => r.number.length >= 7);

        if (!parsed.length) {
          antMessage.error("No valid phone numbers found in the file");
          return;
        }

        setExcelContacts(parsed);
        setExcelFileName(file.name);
        antMessage.success(`${parsed.length} contacts loaded from "${file.name}"`);
      } catch {
        antMessage.error("Failed to parse Excel file");
      }
    };
    reader.readAsArrayBuffer(file);
    e.target.value = "";
  };

  const handleSaveCampaign = async () => {
    if (!campaignName.trim()) {
      return alert("Campaign name is required");
    }

    if (!selectedTemplateOption) {
      return alert("Please select a template");
    }

    if (!selectedTags.length && !excelContacts.length) {
      return alert("Please select at least one group or upload an Excel file with contacts");
    }

    const copyCodeButtons = buttonComponent?.buttons
      ?.map((btn, i) => ({ btn, i }))
      .filter(({ btn }) => btn.type === "COPY_CODE") || [];

    for (const { btn, i } of copyCodeButtons) {
      if (!btn.example && !buttonConfig[i]?.value) {
        return antMessage.error("Please enter a coupon code for the Copy Code button.");
      }
    }

    const dynamicValues = {
      first_name:    "{{first_name}}",
      last_name:     "{{last_name}}",
      phone:         "{{phone}}",
      email:         "{{email}}",
      company_name:  "{{company_name}}",
    };

    const params = buildParams(selectedTemplate, buttonConfig, dynamicValues);

    // ✅ Convert Dubai time to UTC only if scheduled
    // const scheduleUTC = scheduleEnabled && scheduleTime
    //   ? dayjs(scheduleTime).tz("Asia/Dubai", true).utc().toISOString()
    //   : undefined;


    // const payload = {
    //   campaignName: campaignName.trim(),
    //   templateId: selectedTemplateOption.template._id,
    //   groupName: selectedTags.map((tag) => tag.name),
    //   ...(excelContacts.length && { excelNumbers: excelContacts }),
    //   ...(scheduleUTC && { schedule: scheduleUTC }),
    //   ...(Object.keys(params).length && { params })
    // };

    const scheduleUTC = scheduleEnabled && scheduleTime
      ? dayjs(scheduleTime).utc().toISOString()
      : undefined;

    console.log(scheduleUTC, "jhgfdjhgfjhg");
    console.log("scheduleTime", scheduleTime);

    const payload = {
      campaignName: campaignName.trim(),
      templateId: selectedTemplateOption.template._id,
      groupName: selectedTags.map((tag) => tag.name),
      ...(excelContacts.length && { excelNumbers: excelContacts }),
      ...(scheduleUTC && { schedule: scheduleUTC }),
      ...(Object.keys(params).length && { params }),
      ...(Object.keys(fieldDefaults).length && { defaults: fieldDefaults }),
    };

    try {
      const result = await dispatch(addCampaign(payload)).unwrap();
      navigate(-1);
    } catch (error) {
      console.error(error);
      alert(error);
    }
  };


  const buildBodyParams = (template, dynamicValues = {}) => {
    const bodyComponent = template?.components?.find(
      (c) => c.type === "BODY"
    );

    if (!bodyComponent?.example?.body_text_named_params) {
      return null;
    }

    return bodyComponent.example.body_text_named_params.map(
      (p) => dynamicValues[p.param_name] ?? null
    );
  };

  const buildButtonParams = (template, buttonConfig = {}, dynamicValues = {}) => {
    const buttonsComponent = template?.components?.find(
      (c) => c.type === "BUTTONS"
    );

    if (!buttonsComponent?.buttons?.length) {
      return null;
    }

    return buttonsComponent.buttons.map((btn, index) => {
      if (btn.type === "COPY_CODE") {
        return btn.example || buttonConfig[index]?.value || null;
      }

      const cfg = buttonConfig[index];

      if (!cfg || !cfg.value) return null;

      if (cfg.type === "static") {
        return cfg.value || null;
      }

      if (cfg.type === "dynamic") {
        return dynamicValues[cfg.value] ?? null;
      }

      return null;
    });
  };

  const buildParams = (template, buttonConfig, dynamicValues) => {
    const body = buildBodyParams(template, dynamicValues);
    const buttons = buildButtonParams(template, buttonConfig, dynamicValues);

    const params = {};

    if (body && body.length) {
      params.body = body;
    }

    if (buttons && buttons.length) {
      params.buttons = buttons;
    }

    return params;
  };





  return (
    <div className="page-wrapper">
      <div className="content">
        {isWhatsappConnected === false ? (

          <div
            style={{
              height: "70vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <h3>WhatsApp is not connected</h3>
            <p style={{ color: "#888", marginBottom: 20 }}>
              Please configure WhatsApp to start chatting.
            </p>

            <button
              className="btn btn-primary"
              onClick={() => {
                if (userProfile?.role === "companyAdmin") {
                  navigate("/whatsapp/setting");
                }
              }}
              disabled={userProfile?.role !== "companyAdmin"}
            >
              {userProfile?.role === "companyAdmin"
                ? "Go to WhatsApp Settings"
                : "Contact your Company Admin"}
            </button>
          </div>

        ) :
          <>
            <div className="card mt-3">
              <div className="card-body pb-2">
                <h4 className="page-title mb-0">
                  <span onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                    <i className="ti ti-arrow-narrow-left me-3" />
                  </span>
                  Create Campaign
                </h4>
              </div>
            </div>

            <Row gutter={24}>
              {/* LEFT FORM */}
              <Col span={14}>
                <Card>
                  <Space direction="vertical" size="large" style={{ width: "100%" }}>
                    <div>
                      <Text strong>Campaign name</Text>
                      <Input
                        size="large"
                        placeholder="Enter campaign name"
                        value={campaignName}
                        onChange={(e) => setCampaignName(e.target.value)}
                      />
                    </div>

                    <Row gutter={16}>
                      <Col span={12}>
                        <Text strong>Template</Text>
                        <Select
                          options={approvedTemplates}
                          value={selectedTemplateOption}
                          onChange={(opt) => { setSelectedTemplateOption(opt); setButtonConfig({}); setFieldDefaults({}); }}
                          placeholder="Select approved template"
                        />
                      </Col>

                      <Col span={12}>
                        <Text strong>Send To (Groups)</Text>
                        <Select
                          isMulti
                          options={sendToOptions}
                          value={selectedTags}
                          onChange={setSelectedTags}
                          placeholder="Select recipients"
                        />
                      </Col>
                    </Row>

                    {/* Excel Upload */}
                    <div>
                      <Text strong>Upload Contacts from Excel</Text>
                      <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 6 }}>
                        <input
                          ref={fileInputRef}
                          type="file"
                          accept=".xlsx,.xls,.csv"
                          style={{ display: "none" }}
                          onChange={handleExcelUpload}
                        />
                        <Button
                          icon={<UploadOutlined />}
                          onClick={() => fileInputRef.current?.click()}
                        >
                          {excelFileName || "Choose File (.xlsx / .xls)"}
                        </Button>
                        <Button
                          icon={<DownloadOutlined />}
                          size="small"
                          onClick={handleDownloadSample}
                        >
                          Sample File
                        </Button>
                        {excelContacts.length > 0 && (
                          <Button
                            icon={<DeleteOutlined />}
                            danger
                            size="small"
                            onClick={() => { setExcelContacts([]); setExcelFileName(""); }}
                          >
                            Clear
                          </Button>
                        )}
                      </div>
                      {excelContacts.length > 0 && (
                        <div style={{ marginTop: 10 }}>
                          <div style={{ marginBottom: 6, fontSize: 13, color: "#555" }}>
                            <FileExcelOutlined style={{ color: "#1d6f42", marginRight: 6 }} />
                            <strong>{excelContacts.length}</strong> contacts loaded
                          </div>
                          <Table
                            size="small"
                            dataSource={excelContacts.slice(0, 5).map((r, i) => ({ ...r, key: i }))}
                            columns={[
                              { title: "Name", dataIndex: "name", key: "name", render: v => v || <span style={{ color: "#bbb" }}>—</span> },
                              { title: "Number", dataIndex: "number", key: "number" },
                              ...Object.keys(excelContacts[0] || {})
                                .filter(k => k !== "name" && k !== "number")
                                .map(k => ({ title: k, dataIndex: k, key: k, render: v => v || <span style={{ color: "#bbb" }}>—</span> })),
                            ]}
                            pagination={false}
                            footer={() => excelContacts.length > 5 ? `...and ${excelContacts.length - 5} more` : null}
                            style={{ border: "1px solid #f0f0f0", borderRadius: 6 }}
                          />
                          <div style={{ marginTop: 6, fontSize: 12, color: "#888" }}>
                            Expected columns: <Tag>Name</Tag> <Tag>Number</Tag>
                            {bodyComponent?.example?.body_text_named_params?.map(p => (
                              <Tag key={p.param_name} color="blue">{p.param_name}</Tag>
                            ))}
                            (headers are case-insensitive)
                          </div>
                        </div>
                      )}
                      {!excelContacts.length && (
                        <div style={{ marginTop: 6, fontSize: 12, color: "#888" }}>
                          Excel must have columns: <Tag>Name</Tag> <Tag>Number</Tag>
                          {bodyComponent?.example?.body_text_named_params?.map(p => (
                            <Tag key={p.param_name} color="blue">{p.param_name}</Tag>
                          ))}
                          . Numbers should include country code (e.g. 971501234567).
                        </div>
                      )}
                    </div>

                    <div>
                      <Text strong>Scheduled Time</Text>


                      <DatePicker
                        showTime={{
                          use12Hours: true,
                          format: "hh:mm A",
                        }}
                        format="YYYY-MM-DD hh:mm A"
                        size="large"
                        style={{ width: "100%" }}
                        disabled={!scheduleEnabled}
                        onChange={setScheduleTime}
                        disabledDate={(current) => {
                          return current && current < dayjs().startOf("day");
                        }}
                        disabledTime={(current) => {
                          if (!current) return {};

                          const now = dayjs();

                          if (current.isSame(now, "day")) {
                            return {
                              disabledHours: () =>
                                Array.from({ length: now.hour() }, (_, i) => i),
                              disabledMinutes: (selectedHour) =>
                                selectedHour === now.hour()
                                  ? Array.from({ length: now.minute() }, (_, i) => i)
                                  : [],
                              disabledSeconds: () => [],
                            };
                          }

                          return {};
                        }}
                      />



                      <Checkbox
                        style={{ marginTop: 10 }}
                        checked={!scheduleEnabled}
                        onChange={(e) => setScheduleEnabled(!e.target.checked)}
                      >
                        Skip scheduling & send immediately
                      </Checkbox>
                    </div>




                    {bodyComponent?.example?.body_text_named_params?.length > 0 && (
                      <Card size="small" title="Default Values for Missing Fields">
                        <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 8 }}>
                          Used when a contact's field is empty. Leave blank to skip sending to that contact.
                        </Text>
                        {bodyComponent.example.body_text_named_params.map((p) => (
                          <div key={p.param_name} style={{ marginBottom: 8 }}>
                            <Text style={{ fontSize: 12, color: "#555" }}>{`{{${p.param_name}}}`} default:</Text>
                            <Input
                              size="small"
                              style={{ marginTop: 4 }}
                              value={fieldDefaults[p.param_name] || ""}
                              onChange={(e) =>
                                setFieldDefaults(prev => ({ ...prev, [p.param_name]: e.target.value }))
                              }
                              placeholder={`e.g. Customer`}
                            />
                          </div>
                        ))}
                      </Card>
                    )}

                    {buttonComponent?.buttons?.length > 0 && (
                      <Card size="small" title="Template Buttons">
                        {buttonComponent.buttons.map((btn, i) => {
                          const hasDynamicUrl = btn.type === "URL" && /{{.*?}}/.test(btn.url || "");
                          return (
                            <div key={i} style={{ padding: "6px 8px", border: "1px solid #eee", borderRadius: 6, marginBottom: 6, fontSize: 13, color: "#555" }}>
                              {btn.type === "PHONE_NUMBER" && (
                                <span>📞 <strong>{btn.text}</strong> — {btn.phone_number}</span>
                              )}
                              {btn.type === "URL" && !hasDynamicUrl && (
                                <span>🔗 <strong>{btn.text}</strong> — {btn.url}</span>
                              )}
                              {btn.type === "URL" && hasDynamicUrl && (
                                <div>
                                  <div style={{ marginBottom: 4 }}>🔗 <strong>{btn.text}</strong> — URL suffix</div>
                                  <Input
                                    size="small"
                                    value={buttonConfig[i]?.value || ""}
                                    onChange={(e) =>
                                      setButtonConfig(prev => ({
                                        ...prev,
                                        [i]: { type: "static", value: e.target.value }
                                      }))
                                    }
                                    placeholder={`e.g. ${btn.url?.replace(/{{.*?}}/g, "your-value")}`}
                                  />
                                </div>
                              )}
                              {btn.type === "QUICK_REPLY" && (
                                <span>↩ <strong>{btn.text}</strong></span>
                              )}
                              {btn.type === "COPY_CODE" && btn.example && (
                                <span>📋 <strong>{btn.text || "Copy Code"}</strong> — {btn.example}</span>
                              )}
                              {btn.type === "COPY_CODE" && !btn.example && (
                                <div>
                                  <div style={{ marginBottom: 4 }}>📋 <strong>{btn.text || "Copy Code"}</strong> — enter coupon code</div>
                                  <Input
                                    size="small"
                                    value={buttonConfig[i]?.value || ""}
                                    onChange={(e) =>
                                      setButtonConfig(prev => ({
                                        ...prev,
                                        [i]: { type: "static", value: e.target.value }
                                      }))
                                    }
                                    placeholder="Enter coupon code"
                                  />
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </Card>
                    )}



                    <div className="d-flex justify-content-end gap-2">
                      <Button size="large">Cancel</Button>
                      <Button type="primary" size="large" loading={campaignLoading} onClick={handleSaveCampaign}>
                        Save Campaign
                      </Button>
                    </div>
                  </Space>
                </Card>
              </Col>

              {/* RIGHT PREVIEW */}
              <Col span={10}>
                <Card
                  style={{
                    backgroundImage: "url('/assets/img/wabaBg.png')",
                    backgroundRepeat: "repeat",
                    minHeight: 500,
                  }}
                >
                  <Title level={5}>Template Preview</Title>

                  <div
                    style={{
                      background: "#fff",
                      borderRadius: 12,
                      padding: 16,
                    }}
                  >
                    {selectedTemplate ? (
                      <>
                        {renderHeader()}

                        {bodyComponent?.text && (
                          <div style={{ marginBottom: 8 }}>{bodyComponent.text}</div>
                        )}

                        {footerComponent?.text && (
                          <div style={{ fontSize: 12, color: "#888", marginBottom: 12 }}>
                            {footerComponent.text}
                          </div>
                        )}
                        {buttonComponent?.buttons?.map((btn, i) => (
                          <Button
                            key={i}
                            block
                            icon={getBtnIcon(btn.type)}
                            style={{ marginBottom: 8 }}
                          >
                            {getButtonPreviewText(btn, i)}
                          </Button>
                        ))}


                      </>
                    ) : (
                      <Text type="secondary">Select a template to preview</Text>
                    )}
                  </div>
                </Card>
              </Col>
            </Row>
          </>
        }
      </div>
    </div>
  );
};

export default WabaAddCampaign;